import React from 'react';

import { ColorCx } from '@xarvio/corporate-styles';
import { GreyBoxLoader } from '@xarvio/elements';
import { Box, Column, ColumnCell, Panel, Separator } from '@xarvio/layout';
import {
  fieldStatusDetailsPanelContentSkeletons,
  fieldStatusDetailsPanelSkeletonHeights,
} from './skeletonConfig';
import { FieldStatusDetailsPanelSectionSkeleton } from './FieldStatusDetailsPanelSectionSkeleton';

interface Props {
  isPanelCollapsed?: boolean;
  onCollapsedPanelClick?: () => void;
  isPanelOver?: boolean;
  forceBorder?: boolean;
}

const FieldStatusDetailsPanelLoader: React.FC<Props> = ({
  isPanelCollapsed = false,
  onCollapsedPanelClick,
  isPanelOver,
  forceBorder,
}) => {
  return (
    <Panel
      isCollapsed={isPanelCollapsed}
      onClickCollapsed={onCollapsedPanelClick}
      size={'m'}
      blur
      over={isPanelOver}
      forceBorder={forceBorder}
    >
      <Column>
        <ColumnCell bg={ColorCx.WHITE}>
          <GreyBoxLoader
            style={{
              height: fieldStatusDetailsPanelSkeletonHeights.generalFieldInfo,
            }}
          />
          <Separator light />
        </ColumnCell>
        <ColumnCell scrolling noShadows max bg={ColorCx.GREY_200}>
          <Box hpadding={'no'} vpadding={'medium'} margin={false}>
            {fieldStatusDetailsPanelContentSkeletons.map((section) => (
              <FieldStatusDetailsPanelSectionSkeleton
                key={section.key}
                sectionSkeleton={section}
              />
            ))}
          </Box>
        </ColumnCell>
        <ColumnCell bg={ColorCx.WHITE}>
          <Separator light />
          <Box hpadding={'medium'} vpadding={'medium'} margin={false}>
            <GreyBoxLoader
              style={{
                height: fieldStatusDetailsPanelSkeletonHeights.footerActions,
              }}
            />
          </Box>
        </ColumnCell>
      </Column>
    </Panel>
  );
};

export { FieldStatusDetailsPanelLoader };
